import React from 'react'
import { PASSWORD_RULES } from '@/schemas/auth/password'

// Regras exibidas a partir do passwordSchema (PASSWORD_RULES), para o texto não divergir da validação.
const PasswordRequirements: React.FC = () => {
    return (
        <div className="w-full">
            <ul className="list-disc p-4 pl-8 bg-gray rounded-2xl">
                <span className="text-primary text-sm font-bold">A nova senha deve conter:</span>
                <div className="mt-1">
                    <li className="text-primary text-xs">
                        {`${PASSWORD_RULES.min} a ${PASSWORD_RULES.max} caracteres`}
                    </li>
                    <li className="text-primary text-xs">Pelo menos 1 letra maiúscula</li>
                    <li className="text-primary text-xs">
                        {`Pelo menos 1 caractere especial (${PASSWORD_RULES.specials})`}
                    </li>
                </div>
            </ul>
        </div>
    )
}

export default PasswordRequirements
